class DashboardTotalSalesController  {
    constructor(createAutoQuery, $session, $scope) {
        let $ctrl = this;
        let options = {
            url: 'QueryOrderTotals.json',
            criteria: {
                dateRange: $ctrl.date,
                startDate: $ctrl.start,
                endDate: $ctrl.end,
                vendorId: $ctrl.vendor
            },
            autoLoad: true
        };
        $ctrl.query = createAutoQuery(options);
        $ctrl.$session = $session;

        $scope.$watch("$ctrl.date", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.start", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.end", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.vendor", function () {
            $ctrl.reload();
        });
    }
    reload() {
        this.query.criteria.dateRange = this.date;
        this.query.criteria.startDate = this.start;
        this.query.criteria.endDate = this.end;
        this.query.criteria.vendorId = this.vendor;
        this.query.load(true);
    }
}

class DashboardTotalSales{
    constructor(){
        this.bindings= {
            date: '@',
            start: '@',
            end: '@',
            vendor: '@'
        };
        this.controller = DashboardTotalSalesController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-total-sales.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardTotalSales', new DashboardTotalSales());

export default DashboardTotalSales